import { HvacArea, HvacGroup } from '@belimo-retrofit-portal/logic';
import * as R from 'fp-ts/ReadonlyRecord';
import { ReadonlyRecord } from 'fp-ts/ReadonlyRecord';

export const HVAC_GROUP_LIST: ReadonlyArray<HvacGroup> = [
  HvacGroup.EMISSION,
  HvacGroup.DISTRIBUTION,
  HvacGroup.AIR_HANDLER,
  HvacGroup.GENERATION,
];

export const HVAC_GROUP_MAP: ReadonlyRecord<HvacGroup, true> = {
  [HvacGroup.EMISSION]: true,
  [HvacGroup.DISTRIBUTION]: true,
  [HvacGroup.AIR_HANDLER]: true,
  [HvacGroup.GENERATION]: true,
};

export const HVAC_GROUP_AREAS: R.ReadonlyRecord<HvacGroup, ReadonlyArray<HvacArea>> = {
  [HvacGroup.EMISSION]: [
    HvacArea.HEATING,
    HvacArea.COOLING,
    HvacArea.VENTILATION,
  ],
  [HvacGroup.DISTRIBUTION]: [
    HvacArea.HEATING,
    HvacArea.COOLING,
  ],
  [HvacGroup.AIR_HANDLER]: [
    HvacArea.VENTILATION,
  ],
  [HvacGroup.GENERATION]: [
    HvacArea.HEATING,
    HvacArea.COOLING,
  ],
};
